import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
   couponValue: number =0;
   isPromoCode : boolean = false;
   englishTranslation: any = {};
   arabicTranslation: any = {};
   currentUrl:string = '';
   headerTemplateId: any = null;
   headerContentTypeId: number = null;
   headerContentId: number = null;
   headerContetn:string = null;
   menuTemplateId : number = null;
   menuContentTypeId : number = null;
   menuContentId : number = null;
   footerTemplateId : number = null;
   footerContentTypeId : number = null;
   footerContentId : number = null;
   test :  any = {};
}